import { Controller } from "@hotwired/stimulus"
import Toastify from "toastify-js"
import "toastify-js/src/toastify.css"

// Connects to data-controller="toast"
export default class extends Controller {
  // Les surfaces de l'organisateur affichent déjà leurs messages DANS la
  // page (flash inline du design system, lisibles sans JavaScript). Quand
  // la page en porte un, on ne double pas d'un bandeau flottant.
  static FLASH_INLINE = ".flash-notice, .flash-alert, .flash-nuit-notice, .flash-nuit-alert"

  connect() {
    const type = this.element.dataset.toastType
    const message = this.element.dataset.toastMessage

    if (document.querySelector(this.constructor.FLASH_INLINE)) {
      this.element.remove()
      return
    }

    if (message) {
      this.show(message, type)
    }
  }

  show(text, type = "info") {
    const backgrounds = {
      notice: "linear-gradient(to right, #00b09b, #96c93d)",  // Vert success
      success: "linear-gradient(to right, #00b09b, #96c93d)",
      alert: "linear-gradient(to right, #ff5f6d, #ffc371)",   // Orange warning
      error: "linear-gradient(to right, #eb3349, #f45c43)",   // Rouge error
      info: "linear-gradient(to right, #667eea, #764ba2)"     // Bleu info
    }

    Toastify({
      text: text,
      duration: 4000,
      close: true,
      gravity: "bottom",  // bottom or top
      position: "right",  // left, center or right
      stopOnFocus: true,
      style: {
        background: backgrounds[type] || backgrounds.info,
        borderRadius: "12px",
        padding: "16px 24px",
        fontSize: "14px",
        fontWeight: "500",
        boxShadow: "0 10px 25px rgba(0,0,0,0.2)"
      }
    }).showToast()

    // Supprimer l'élément du DOM après affichage
    this.element.remove()
  }
}
